import React, { memo, useState } from "react";
import {
    Modal,
    Box,
    Typography,
    Button,
    IconButton,
    Tooltip,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import EmailIcon from "@mui/icons-material/Email";
import Swal from "sweetalert2";
import { DisabledByDefault } from "@mui/icons-material";
import configServ from "../../services/config";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../redux/reducers/LoaderTrigger";

// FUNCTION
const PrintSendPrescription = ({ prescription, onClose }) => {
    const [loading, setLoading] = useState(false);

    const onEmail = async () => {
        try {
            const dataToSend = {
                id: prescription.id,
                item_id: prescription.item_id,
                user_id: prescription.user_id,
            }
            const res = await configServ.sendPrescriptionPdf(dataToSend);
            if (res.status === 200) {
                onClose();
                Swal.fire({
                    'icon': 'success',
                    'title': 'Success',
                    'text': res.message || 'Prescription mailed successfully.'
                });
            }
            else {
                Swal.fire({
                    'icon': 'error',
                    'title': 'Error',
                    'text': 'Failed to mail Prescription.'
                });
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const onPrint = async () => {
        try {
            const dataToSend = {
                id: prescription.id,
                item_id: prescription.item_id,
                user_id: prescription.user_id,
            }
            const res = await configServ.getPrescriptionPdf(dataToSend);
            // Create a blob from the response
            const blobFile = new Blob([res], { type: 'application/pdf' });

            // Generate a URL for the blob and open it
            const url = window.URL.createObjectURL(blobFile);
            window.open(url);
        }
        catch (e) {
            console.log("Error in pdf: ",e);
        }
    }

    const handleAction = async (action) => {
        try {
            setLoading(true);
            if (action === "print") {
                await onPrint(); // Call the print API
            }
            else if (action === "email") {
                await onEmail(); // Call the email API
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open={Boolean(prescription)}
            onClose={onClose}
            aria-labelledby="prescription-modal-title"
            aria-describedby="prescription-modal-description"
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    border: "2px solid #000",
                    boxShadow: 24,
                    p: 0,
                    borderRadius: 2,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography id="prescription-modal-title" variant="h6" component="h2" ml={3}>
                        Prescription
                    </Typography>
                    <IconButton onClick={onClose} sx={{ fontSize: '36px' }}>
                        <DisabledByDefault color="error" fontSize="36px" />
                    </IconButton>
                </Box>
                <Typography
                    id="prescription-modal-description"
                    sx={{ mt: 2, mb: 3, textAlign: "center" }}
                >
                    Choose an option to proceed.
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "space-around", pb: 3 }}>
                    <Tooltip title="Print Prescription" placement="top" arrow>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<PrintIcon />}
                            onClick={() => handleAction("print")}
                            disabled={loading}
                        >
                            Print
                        </Button>
                    </Tooltip>
                    <Tooltip title="Email Prescription" placement="top" arrow>
                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<EmailIcon />}
                            onClick={() => handleAction("email")}
                            disabled={loading}
                        >
                            Email
                        </Button>
                    </Tooltip>
                </Box>
            </Box>
        </Modal>
    );
};

export default memo(PrintSendPrescription);
